/**
 * MK-4 — every mark carries a code, each kind counting from 1 on its own:
 * points 1, 2, 3 · clouds C-1 · highlights H-1 · pens P-1 · arrows A-1 · brackets B-1.
 * The server numbers a mark when it is saved; before that the code is
 * provisional (next free number of that kind, in the order drawn). Pure.
 */
export const KIND_OF = {
  point: 'point', arrow: 'arrow', cloud: 'cloud', highlight: 'highlight',
  pen: 'pen', freehand: 'pen', rectangle: 'highlight', note: 'point', text: 'point',
  bracket: 'bracket',
};

export const PREFIX = { point: '', arrow: 'A-', cloud: 'C-', highlight: 'H-', pen: 'P-', bracket: 'B-' };

export const kindOf = (m) => KIND_OF[m?.type] || 'point';

/** The number this mark shows: its own, or the next free one of its kind. */
export const numberFor = (mark, all) => {
  if (mark.number) return mark.number;
  const kind = kindOf(mark);
  const same = (all || []).filter((m) => kindOf(m) === kind);
  const top = same.reduce((n, m) => Math.max(n, m.number || 0), 0);
  const unsaved = same.filter((m) => !m.number);
  const at = unsaved.findIndex((m) => m.id === mark.id);
  return top + (at < 0 ? unsaved.length : at) + 1;
};

export const codeFor = (mark, all) => `${PREFIX[kindOf(mark)]}${numberFor(mark, all)}`;

/** Server-side twin, for the test: next number within a kind. */
export const nextNumberOfKind = (marks, kind) =>
  (marks || []).filter((m) => kindOf(m) === kind).reduce((n, m) => Math.max(n, m.number || 0), 0) + 1;
